import { Tooltip } from 'primereact/tooltip';

const AIEduTooltip = (props) => {
    return (
        <>
            <Tooltip
                style={{ fontFamily: 'SamsungOne-400, sans-serif' }}
                showDelay={200}
                {...props}
            />
        </>
    );
};

export default AIEduTooltip;
